<p-autoComplete
  [ngModel]="selectedUsers"
  (ngModelChange)="onSelectionChange($event)"
  [suggestions]="suggestions"
  (completeMethod)="complete($event)"
  [optionLabel]="userLabel"
  [multiple]="true"
  [dropdown]="true"
  [completeOnFocus]="true"
  [forceSelection]="true"
  [showClear]="true"
  [disabled]="disabled"
  [emptyMessage]="emptyMessage"
  [placeholder]="placeholder"
  (onBlur)="handleBlur()"
  fluid>

  <ng-template #item let-user>
    <div class="user-option">
      <span class="user-option-name">{{ user.firstname }} {{ user.lastname }} ({{ user.email }})</span>
      @if (user.account?.clientNumber) {
        <span class="user-option-account">{{ user.account.clientNumber }} {{ user.account.company }}</span>
      }
    </div>
  </ng-template>
</p-autoComplete>

@if (truncated) {
  <p-message severity="warn" size="small" variant="simple" i18n="account user selector|Truncation hint">
    Only the first {{ maxUsers }} users of this account are offered.
  </p-message>
}
